import queryString from 'query-string';

export type CampaignParams = Readonly<{
  params: Record<string, string | undefined>;
  firstParams: Record<string, string | null>;
}>;

const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'] as const;

/** Last-touch and first-touch UTM properties shared by every analytics vendor. */
export function getCampaignParams(): CampaignParams | undefined {
  if (!window.location.search) return undefined;

  const queryParams = queryString.parse(window.location.search);
  const params: Record<string, string | undefined> = {};
  const firstParams: Record<string, string | null> = {};
  let matchFound = false;
  for (const name of UTM_KEYS) {
    const value = queryParams[name];
    const single = Array.isArray(value) ? value[0] : value;
    if (single) matchFound = true;
    params[`${name} [last touch]`] = single ?? undefined;
    firstParams[`${name} [first touch]`] = single || null;
  }
  return matchFound ? { params, firstParams } : undefined;
}
